<template>
    <v-card outlined elevation="3" class="blue-grey darken-4">
        <v-card-title class="pl-1 pt-0 mt-0">
            {{ $t('login') }}
        </v-card-title>
        <v-card-text class="pa-2">
            <span v-if="loginPrompt">{{ $t('you must login') }}</span>

            <div>
                <v-btn class="v-btn success mt-5" @click="useAuthProvider('google', Google)"><v-icon class="mr-2">mdi-google</v-icon> {{ $t('login google') }}</v-btn>
            </div>
            <div>
                <v-btn class="v-btn success mt-5" @click="useAuthProvider('facebook', Facebook)"><v-icon class="mr-2">mdi-facebook</v-icon> {{ $t('login facebook') }}</v-btn>
            </div>
            <div class="mt-3 mb-3">
                {{ $t('or form below') }}
            </div>

            <v-form v-model="valid" ref="form">

                <v-text-field
                    :label="$t('enter email')"
                    v-model="login_email"
                    :rules="[
                                    (v) => !!v || $t('field required'),
                                    (v) => /^\w+([.-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/.test(v) || $t('not valid email')
                                ]"
                    required
                    outlined
                    class="form-input"
                    background-color="blue-grey darken-4"
                ></v-text-field>

                <v-text-field
                    :label="$t('enter password')"
                    v-model="login_pass"
                    :append-outer-icon="e1 ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append-outer="e1 = !e1"
                    :type="e1 ? 'password' : 'text'"
                    :rules="[
                                    (v) => !!v || $t('field required'),
                                ]"
                    required
                    outlined
                    class="form-input"
                    background-color="blue-grey darken-4"
                ></v-text-field>

                <v-alert v-if="login_errors" type="error">
                    {{ $t(login_errors) }}
                </v-alert>

                <v-alert v-if="social_error" type="error">
                    {{ social_error }}
                </v-alert>

                <v-layout justify-space-between>
                    <v-btn @click="login" class="v-positive-button">
                        <v-icon>mdi-login</v-icon>
                        {{ $t('login') }}
                    </v-btn>
                </v-layout>

                <v-divider></v-divider>

                <v-layout justify-space-between class="mt-5 text-center">
                    <span class="vs-link" @click="$router.push({name: 'ResetPass'});$emit('login_dialog', false)">{{ $t('forgot pass') }}</span>
                    <span class="vs-link" @click="$router.push({name: 'Register'});$emit('login_dialog', false)">{{ $t('register new') }}</span>
                </v-layout>
            </v-form>
        </v-card-text>


    </v-card>
</template>

<script>
import { Providers} from 'universal-social-auth'
import { Google, Facebook } from 'universal-social-auth'
export default {
    name: "LoginForm",
    data() {
        return {
            login_email: null,
            login_pass: null,
            login_remember: true,
            login_errors: false,
            social_error: false,
            login_prompt: false,
            valid: false,
            e1: true,
            Google,
            Facebook
        }
    },
    props: {
        loginPrompt: Boolean
    },
    methods: {
        useAuthProvider (provider, proData) {
            this.social_error = false;
            const pro = proData

            const ProData = pro || Providers[provider]
            this.$Oauth.authenticate(provider, ProData).then((response) => {
                const code = response.code
                this.axios.post('/auth/social_login/'+provider, {code: code}).then((response) => {
                    console.log('token: '+response.data)
                    this.axios.defaults.headers.common = {'Authorization': response.data}

                    //store token to cookie
                    this.$cookies.set('login_remember', response.data, 15552000) //half a year

                    this.$gtag.event('login')

                    window.location.reload()
                }).catch((err) => {
                    console.log(err)
                    this.social_error = this.$t('social login error', [provider])
                })
            }).catch((err) => {
                console.log(err)
                this.social_error = this.$t('social login error', [provider])
            })

        },

        login(){
            console.log('login')
            this.social_error = false;
            this.login_errors = false
            this.axios.post('/auth/token', {
                email: this.login_email,
                password: this.login_pass,
                device_name: 'api',
            })
                .then(response => {

                    console.log('response', response)
                    this.axios.defaults.headers.common = {'Authorization': response.data}

                    //store token to cookie
                    if(this.login_remember)
                        this.$cookies.set('login_remember', response.data, 15552000) //half a year

                    this.$gtag.event('login')

                    window.location.reload()
                })
                .catch(e => {
                    console.log(e.response.data.error)
                    if(e.response.data.error == 'The provided credentials are incorrect.')
                        this.login_errors = 'The provided credentials are incorrect.'
                    else
                        this.login_errors = 'internal error';
                })
        },
    }
}
</script>

<style scoped>
</style>
